module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "fmh"
  }, [_c('a', {
    attrs: {
      "id": "page_viii"
    }
  }), _c('a', {
    attrs: {
      "id": "page_ix"
    }
  }), _c('span', {
    staticClass: "bold"
  }, [_vm._v("Acknowledgments")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("I am greatly indebted to a number of people whose input and support made this book possible. Foremost is Professor Phillip Scribner who provided an intellectual framework for understanding the unfolding of societal evolution and who was more than generous in his efforts reviewing formative drafts of this book. Equally generous was Douglas Seay, who brought his extensive understanding of history and political science to bear in critiquing multiple drafts of this work. Furthermore, Paula Jo Galbraith’s communications skills were invaluable for improving its clarity, strength of argument, and flow. Also, I wish to acknowledge Carole Sargent’s assistance in finding a publisher. And, of course, the patience and loving support of my life partner Ken George was essential for the completion of this long-term endeavor.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent2"
  }, [_vm._v("Excerpts from "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Story of Civilization")]), _vm._v(": volumes I through VII by Will and Ariel Durant. Copyright © 1935, 1939, 1944, 1950, 1953 by Will Durant. Copyright © renewed 1963, 1967, 1972, 1978. 1957 by Will Durant. Copyright © renewed 1985 by Ethel B. Durant. 1961 by Will Durant. Copyright © renewed 1983 by Will & Ariel Durant. Reprinted with the permission of Simon & Schuster, Inc.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Figures 7.1, 7.2, and 7.3 of "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Culture Matters")]), _vm._v(" by Lawrence E. Harrison and Samuel P. Huntington, Copyright © 2000, reprinted by permission of Basic Books, a member of Perseus Books Group.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c22f3a22","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/07_acknowledgements.vue
// module id = 78
// module chunks = 0